import {API_URL} from "../../dev";
import "isomorphic-fetch";

class SponsorApi {
	async getSponsorReservationSeats(merchantId, themeName, eventUUID) {
		try {
			const response = await fetch(
				`${API_URL}/v1/sponsoring/public/reservations/${merchantId}_${themeName}` +
				`/${eventUUID}`, {
					method: 'GET',
					headers: {
						Accept: 'application/json',
					}
				});
			const obj = await response.json();
			if (response.ok) {
				return obj;
			}
			throw obj;
		} catch (e) {
			console.error(`Error occurred in create reservation: ${JSON.stringify(e)}`,
				`${API_URL}/v1/sponsoring/public/reservations/${merchantId}_${themeName}` +
				`/${eventUUID}`);
			throw e;
		}
	}

	async lookupCodeUsagesAndPriceLevel(merchantId, themeName, sponsorCode) {
		const searchParams = new URLSearchParams({code: sponsorCode});
		try {
			const response = await fetch(
				`${API_URL}/v1/sponsoring/${merchantId}_${themeName}/codes/validate?${searchParams}`);
			const responseObj = await response.json();
			if (response.ok) {
				return responseObj;
			}
			throw responseObj;
		} catch (e) {
			console.error(`Error occurred in lookupPriceLevel: ${JSON.stringify(e)}`);
			throw e;
		}
	}
}

const sponsorApi = new SponsorApi();
export default sponsorApi;
